/** Base URL for GoHighLevel CRM contact detail (append the GHL contact id, not the internal DEFIT id). */
export const GHL_CRM_CONTACT_DETAIL_BASE = "https://crm.intentscaling.com/v2/location/18aelxDTX4uTYjqh5vI7/contacts/detail/";
export function getGhlContactDetailHref(ghlContactId) {
    const id = ghlContactId?.trim();
    if (!id)
        return null;
    return `${GHL_CRM_CONTACT_DETAIL_BASE}${id}`;
}
